// TODO: move to separate library
import {
  format as dateFNSFormat,
  parse as dateFNSParse,
  parseISO as dateFNSParseISO,
} from 'date-fns';
export { isEqual as dateFNSIsEqual } from 'date-fns/isEqual';
export { addMinutes as dateFNSAddMinutes } from 'date-fns/addMinutes';
export { subMinutes as dateFNSSubMinutes } from 'date-fns/subMinutes';

export type DateInput = number | string | Date | null;

export const parseDate = (date: DateInput, format?: string) => {
  if (format && typeof date === 'string') {
    return dateFNSParse(date, format, new Date());
  }
  if (typeof date === 'number') {
    return new Date(date);
  }
  if (typeof date === 'string') {
    return dateFNSParseISO(date);
  }
  if (date instanceof Date) {
    return date;
  }
  return new Date();
};

export const formatDateTime = (date: Date, format: string) => {
  return dateFNSFormat(date, format);
};

export const getIsoWeekday = (date: Date = new Date()) => {
  const weekDay = date.getDay() - 1;
  if (weekDay < 0) {
    return 6;
  }
  return weekDay;
};
